import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {FaEye, FaEyeSlash, FaLock} from "react-icons/fa";
import { authAPI } from '../../../api/api.js';
import { useLanguage } from '../../../context/LanguageContext.js';
import ButtonWithLoader from '../../../components/Button/ButtonLoader/ButtonLoader.js';
import AuthBrand from '../AuthBrand/AuthBrand.jsx';

const ResetPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const { t } = useLanguage();
    const [formData, setFormData] = useState({
        password: '',
        confirmPassword: ''
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setMessage('');

        if (formData.password !== formData.confirmPassword) {
            setError(t('auth.resetPassword.mismatch'));
            setLoading(false);
            return;
        }

        if (formData.password.length < 8) {
            setError(t('auth.resetPassword.tooShort'));
            setLoading(false);
            return;
        }

        try {
            await authAPI.resetPassword(token, formData.password, formData.confirmPassword);
            setMessage(t('auth.resetPassword.success'));
            setTimeout(() => {
                navigate('/login');
            }, 2000);
        } catch (err) {
            setError(err.response?.data?.message || t('auth.resetPassword.failed'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className='auth-page'>
            <AuthBrand corner to="/login" />
            <section className='reset-password-section'>
                <div className="auth-shell container">

                    <form className="auth-card" onSubmit={handleSubmit}>
                        <p className="auth-eyebrow">{t('auth.resetPassword.eyebrow')}</p>
                        <h2 className='auth-title'>
                            {t('auth.resetPassword.title')}
                        </h2>
                        <p className="auth-lede">{t('auth.resetPassword.lede')}</p>

                        <div className="auth-fields">
                            <div className='auth-field'>
                                <FaLock className='auth-field-icon'/>
                                <div className='auth-field-control'>
                                    <input
                                        className="auth-input"
                                        type={showPassword ? 'text' : 'password'}
                                        value={formData.password}
                                        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                        placeholder=" "
                                        required
                                        minLength="8"
                                    />
                                    <label className="auth-input-label">
                                        {t('auth.resetPassword.newPassword')}
                                    </label>
                                    <button
                                        type="button"
                                        className="auth-password-toggle"
                                        onClick={() => setShowPassword(!showPassword)}
                                        aria-label={showPassword ? t('auth.fields.hidePassword') : t('auth.fields.showPassword')}
                                    >
                                        {showPassword ? <FaEyeSlash className="auth-password-icon" /> : <FaEye className="auth-password-icon" />}
                                    </button>
                                </div>
                            </div>

                            <div className='auth-field'>
                                <FaLock className='auth-field-icon'/>
                                <div className='auth-field-control'>
                                    <input
                                        className="auth-input"
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        value={formData.confirmPassword}
                                        onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                                        placeholder=" "
                                        required
                                        minLength="8"
                                    />
                                    <label className="auth-input-label">
                                        {t('auth.resetPassword.confirmPassword')}
                                    </label>
                                    <button
                                        type="button"
                                        className="auth-password-toggle"
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                        aria-label={showConfirmPassword ? t('auth.fields.hidePassword') : t('auth.fields.showPassword')}
                                    >
                                        {showConfirmPassword ? <FaEyeSlash className="auth-password-icon" /> : <FaEye className="auth-password-icon" />}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="auth-action-box">
                            <ButtonWithLoader
                                text={t('auth.resetPassword.submit')}
                                loading={loading}
                                type="submit"
                            />
                        </div>

                        <br/>
                        <div className="auth-helper-note">
                            {t('auth.resetPassword.helper')}
                        </div>

                        {message && <p className="auth-message auth-message--success">{message}</p>}
                        {error && <p className="auth-message auth-message--error">{error}</p>}
                    </form>

                </div>
            </section>
        </main>
    );
};

export default ResetPassword;
